import React from 'react';
import { Typography } from 'components/atoms';
import { NewBreadCrumb } from 'components/molecules';
import { VehicleListEditor } from 'components/organisms';
import { ViewScreen } from 'components/template';
import './index.scss';

export const MyVehicles = () => {
  const headerItem1 = (
    <>
      <Typography type="heading5" text="Aventude Pvt Ltd" />
      <NewBreadCrumb />
    </>
  );

  return (
    <ViewScreen
      portalTitle="Employee Portal"
      headerItem1={headerItem1}
      mainItem1={
        <section className="my-vehicles">
          <div className="my-vehicles__intro">
            <Typography type="heading5" text="My Vehicles" weight="bold" />
            <Typography
              type="small_medium"
              color="gray"
              text="Add the vehicles you park at the office. This is optional, and you can add more than one."
            />
          </div>
          <VehicleListEditor target="me" />
        </section>
      }
    />
  );
};
